<template>
<v-container fluid class="down-top-padding">
    <v-row>
        <v-col cols="12" sm="12">
            <BaseCard heading="Шаҳарлар - жадвали">
                <v-data-table :headers="headers" :items="rows" :items-per-page="5" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Қидирув" single-line hide-details></v-text-field>
                            </v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="edit = false">
                                        Янги шаҳар
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Шаҳар</span>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field label="Шаҳар номи" required v-model="formData.name"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog = false">
                                            Бекор қилиш
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="submit">
                                            Сақлаш
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                       <!-- <v-icon small @click="DeleteItem(item)">
                            mdi-delete
                        </v-icon> -->
                    </template>
                </v-data-table>
            </BaseCard>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import {
    getCities,
    postCities,
    putCities,
    deleteCities
} from '../../api/cities'

export default {
    data() {
        return {
            dialog: false,
            edit: false,
            search: '',
            headers: [{
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Номи',
                    value: 'name'
                },
                {
                    text: 'Амаллар',
                    value: 'actions',
                    sortable: false
                },
            ],
            rows: [],
            formData: {
                name: null
            }
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        fetchData() {
            getCities().then(res => {
                console.log(res)
                this.rows = res.data
            }).catch(error => {
                console.log(error)
            })
        },
        submit() {
            if (!this.edit) {
                postCities(this.formData).then(() => {
                    this.dialog = false
                    this.fetchData()
                    this.resetData()
                }).catch(error => {
                    console.log(error)
                })
            } else {
                putCities(this.formData, this.formData.id).then(() => {
                    this.dialog = false
                    this.fetchData()
                    this.resetData()
                }).catch(error => {
                    console.log(error)
                })
            }

        },
        editItem(item) {
            this.dialog = true
            this.formData = item
            this.edit = true

        },        
        DeleteItem(item) {
            deleteCities(item.id).then(() => {
                this.fetchData()
            })
        },
        resetData() {
            this.formData = {
                name: null
            }
        }
    }
}
</script>
